import { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import Logo from "../../assets/images/forgotpass.png"
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from "react-toastify";

const Forgotpassword = () => {




  const [errMsg, setErrMsg] = useState("");



  const currentUrl = window.location.href;


  const urlParts = currentUrl.split('/');


  const baseUrl = urlParts[0] + `//` + urlParts[2];



  const [formData, setFormData] = useState({
    email: "",
    url: baseUrl
  });



  const [errors, setErrors] = useState({});

  const [inputState, setInputState] = useState({});



  const validateForm = () => {
    const newErrors = {};


    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }


    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false); //loading logic



  const handleSubmit = async (e) => {
    e.preventDefault();


    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic

      try {
        let res = await axios.post(`${BASE_URL}/user/forgotpassword/`, formData);


        if (res.status === 200) {
          // Open Gmail in a new tab/window
          window.open("https://mail.google.com/", "_blank");
        }
        else {
          setErrMsg(res.error)
        }
      } catch (err) {

        setErrMsg(err.response.data.error)

        if (err.response) {
          toast.dismiss(loadingToastId);
          const errorData = err.response.data;
          if (typeof errorData.error === 'string') { // Single error message   
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === 'object' && errorData !== null) {// Multiple error messages
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach(message => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error('Error:- Failed to Process!');
          }
        } else {
          toast.error('Error processing your request.');
        }

      } finally {
        setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
        toast.dismiss(loadingToastId);
      }
    } else {
      console.log('Form contains errors:', errors);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });


    setFormData({
      ...formData,
      [name]: value,
    });
  };


  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className='login-page'>
        <div>
          <Link to="/">
            <img src={Logo} alt='logo' className=' login-page-img width-25vw' /></Link>
        </div>
        <div className='login-page-right width-35vw'>

          <div className='login-page-second-heading   font-weight600'>Forgot Password</div>

          <form onSubmit={handleSubmit} className="register-form">
            <div className="flex-column">
              <label htmlFor="email" className='form-labels'>Email</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="example@gmail.com"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.email}
                onInput={(e) => {
                  e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                }}
                className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
              />
              {errors.email && (
                <span className="error-message font-size-text ">{errors.email}</span>
              )}</div>


            <div>
              <button type="submit" className="login-button font-weight600  font-size-heading" disabled={loading} >{/* //loading logic */}
                Reset Password
              </button></div>
            <p
              style={{ color: "red" }}
              className={errMsg ? "errmsg" : "offscreen"}
              aria-live="assertive"
            >
              {errMsg}
            </p>

          </form>

        </div>
      </div>
    </>
  )
}

export default Forgotpassword